import { render, staticRenderFns } from "./items-grid-04.vue?vue&type=template&id=207f7c30&scoped=true&"
import script from "./items-grid-04.vue?vue&type=script&lang=js&"
export * from "./items-grid-04.vue?vue&type=script&lang=js&"
import style0 from "./items-grid-04.vue?vue&type=style&index=0&id=207f7c30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207f7c30",
  null
  
)

export default component.exports